export default "__VITE_ASSET__Cia9TKsM__"